const css = `.dicv2W__gridContainer{grid-template-columns:fit-content(90%) auto;gap:16px 24px;display:grid}.dicv2W__gridContainer>*{word-break:break-all}`;
document.head
    .appendChild(document.createElement("style"))
    .appendChild(document.createTextNode(css));
export {css};

export default {"gridContainer":"dicv2W__gridContainer"};
